"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyTelemetry = void 0;
class EmptyTelemetry {
    sendEvent(eventName, properties, timecost) { }
    async sendEventWithDuration(eventName, action) {
        return await action();
    }
    sendUserErrorEvent(eventName, errorMessage) { }
    sendSystemErrorEvent(eventName, errorMessage, errorStack) { }
}
exports.EmptyTelemetry = EmptyTelemetry;
//# sourceMappingURL=depsTelemetry.js.map